import Skeleton from "react-loading-skeleton";
import clsx from "clsx";

import classes from "./styles.module.scss";

export function PageSkeleton() {
  return (
    <div className={clsx(classes.container)}>
      <Skeleton width={"100%"} height={"100%"} />
    </div>
  );
}
